/** Admin core: AdminLayout nav/logout + AdminFoodSubcategories — ko/en/vi/ru */

const nav = {
  dashboard: ['대시보드', 'Dashboard', 'Bảng điều khiển', 'Панель управления'],
  businesses: ['업체 관리', 'Businesses', 'Quản lý doanh nghiệp', 'Управление бизнесами'],
  businessApproval: ['업체 승인', 'Business approval', 'Duyệt doanh nghiệp', 'Одобрение бизнеса'],
  catalogApproval: [
    '상품·메뉴 승인',
    'Catalog & menu approval',
    'Duyệt sản phẩm/thực đơn',
    'Одобрение товаров и меню',
  ],
  foodSubcategories: [
    '음식 카테고리 아이콘',
    'Food category icons',
    'Biểu tượng danh mục món ăn',
    'Иконки категорий еды',
  ],
  businessClaims: [
    '가게 클레임',
    'Business claims',
    'Yêu cầu xác nhận cửa hàng',
    'Заявки на владение бизнесом',
  ],
  reviews: ['리뷰 관리', 'Reviews', 'Quản lý đánh giá', 'Управление отзывами'],
  noShows: ['노쇼 관리', 'No-show management', 'Quản lý bỏ hẹn', 'Управление неявками'],
  bookings: ['예약 관리', 'Bookings', 'Quản lý đặt chỗ', 'Управление бронированиями'],
  settlements: ['정산 관리', 'Settlements', 'Quản lý quyết toán', 'Управление расчётами'],
  stats: ['통계', 'Stats', 'Thống kê', 'Статистика'],
  inquiries: ['광고문의', 'Ad inquiries', 'Yêu cầu quảng cáo', 'Запросы по рекламе'],
  travelQuotes: ['여행 견적문의', 'Travel quotes', 'Yêu cầu báo giá du lịch', 'Запросы на тур'],
  shortsQueue: ['AI 쇼츠 큐', 'AI Shorts queue', 'Hàng đợi Shorts AI', 'Очередь AI Shorts'],
  chargeRequests: [
    '포인트 충전 요청',
    'Point top-up requests',
    'Yêu cầu nạp điểm',
    'Запросы пополнения баллов',
  ],
  bizChargeRequests: [
    '업체 크레딧 충전요청',
    'Business credit top-up requests',
    'Yêu cầu nạp tín dụng doanh nghiệp',
    'Запросы пополнения кредитов бизнеса',
  ],
  subscriptions: ['구독 관리', 'Subscriptions', 'Quản lý gói đăng ký', 'Управление подписками'],
  users: ['유저관리', 'Users', 'Quản lý người dùng', 'Управление пользователями'],
  ads: ['광고관리', 'Ads', 'Quản lý quảng cáo', 'Управление рекламой'],
  adBotSettings: [
    '광고 AI 상담봇 설정',
    'Ad AI chatbot settings',
    'Cài đặt chatbot AI quảng cáo',
    'Настройки AI-чата для рекламы',
  ],
  posts: ['게시글관리', 'Posts', 'Quản lý bài viết', 'Управление публикациями'],
  properties: ['매물 관리', 'Properties', 'Quản lý bất động sản', 'Управление недвижимостью'],
  hotels: ['호텔 관리', 'Hotels', 'Quản lý khách sạn', 'Управление отелями'],
  rentals: ['렌탈 관리', 'Rentals', 'Quản lý cho thuê', 'Управление арендой'],
  hospitals: ['병원 관리', 'Hospitals', 'Quản lý bệnh viện', 'Управление больницами'],
  medicines: ['약품 관리', 'Medicines', 'Quản lý thuốc', 'Управление лекарствами'],
  academies: ['학원 관리', 'Academies', 'Quản lý trung tâm học', 'Управление курсами'],
  restaurants: ['식당 관리', 'Restaurants', 'Quản lý nhà hàng', 'Управление ресторанами'],
  visaServices: [
    '비자/행정 관리',
    'Visa & admin services',
    'Quản lý visa/hành chính',
    'Управление визами и админ. услугами',
  ],
  scam: ['사기경고', 'Scam alerts', 'Cảnh báo lừa đảo', 'Предупреждения о мошенничестве'],
  notice: ['공지사항', 'Notices', 'Thông báo', 'Объявления'],
  businessVerify: [
    '업체인증',
    'Business verification',
    'Xác minh doanh nghiệp',
    'Верификация бизнеса',
  ],
  reports: ['신고관리', 'Reports', 'Quản lý báo cáo', 'Управление жалобами'],
  tierA: ['Tier A 운영', 'Tier A ops', 'Vận hành Tier A', 'Управление Tier A'],
  systemOps: ['시스템·플래그', 'System & flags', 'Hệ thống & cờ tính năng', 'Система и флаги'],
  system: ['시스템설정', 'System settings', 'Cài đặt hệ thống', 'Настройки системы'],
};

const chrome = {
  logout: ['로그아웃', 'Log out', 'Đăng xuất', 'Выйти'],
  navAriaLabel: ['어드민 메뉴', 'Admin menu', 'Menu quản trị', 'Меню администратора'],
  citySubtitle: [
    '도시 관리자 · {city}',
    'City admin · {city}',
    'Quản trị viên thành phố · {city}',
    'Городской админ · {city}',
  ],
};

const foodIcons = {
  pageTitle: [
    '허브 카테고리 아이콘',
    'Hub category icons',
    'Biểu tượng danh mục hub',
    'Иконки категорий хаба',
  ],
  pageDesc: [
    '우선순위: 관리자 덮어쓰기 → 실제 메뉴 사진 → 관리자/시드 이미지 → 이모지.',
    'Priority: admin override → real menu photo → admin/seed image → emoji.',
    'Thứ tự ưu tiên: ghi đè quản trị → ảnh món thực tế → ảnh quản trị/mặc định → biểu tượng cảm xúc.',
    'Приоритет: переопределение админом → реальное фото блюда → изображение админа/по умолчанию → эмодзи.',
  ],
  domainFood: ['음식', 'Food', 'Món ăn', 'Еда'],
  domainCafe: ['카페', 'Cafe', 'Cà phê', 'Кафе'],
  domainMart: ['마트', 'Mart', 'Tạp hóa', 'Магазин'],
  scopeTop: [
    '최상위 (허브 그리드)',
    'Top level (hub grid)',
    'Cấp cao nhất (lưới hub)',
    'Верхний уровень (сетка хаба)',
  ],
  scopeSub: ['서브카테고리', 'Subcategory', 'Danh mục con', 'Подкатегория'],
  parentCategoryLabel: ['상위 카테고리', 'Parent category', 'Danh mục cha', 'Родительская категория'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  emptyList: [
    '등록된 항목이 없습니다.',
    'No items registered.',
    'Chưa có mục nào được đăng ký.',
    'Нет зарегистрированных элементов.',
  ],
  iconTypeRealPhoto: [
    '실제 등록 메뉴 사진 사용 중',
    'Using real registered menu photo',
    'Đang dùng ảnh món ăn thực tế',
    'Используется реальное фото блюда',
  ],
  iconTypeAdminUpload: [
    '관리자 업로드 이미지',
    'Admin-uploaded image',
    'Ảnh do quản trị viên tải lên',
    'Изображение, загруженное админом',
  ],
  iconTypeEmoji: [
    '이모지 폴백',
    'Emoji fallback',
    'Biểu tượng cảm xúc dự phòng',
    'Резервный эмодзи',
  ],
  autoMatching: [
    '자동 매칭 중',
    'auto-matching',
    'đang tự động khớp',
    'автоподбор',
  ],
  preferAdminOn: ['prefer_admin_icon=ON', 'prefer_admin_icon=ON', 'prefer_admin_icon=ON', 'prefer_admin_icon=ON'],
  processing: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  uploadImage: ['이미지 업로드', 'Upload image', 'Tải ảnh lên', 'Загрузить изображение'],
  preferRealPhoto: [
    '실사진 우선으로',
    'Prefer real photo',
    'Ưu tiên ảnh thực',
    'Приоритет реальному фото',
  ],
  preferAdminImage: [
    '관리자 이미지 덮어쓰기',
    'Override with admin image',
    'Ghi đè bằng ảnh quản trị',
    'Заменить изображением админа',
  ],
  removeImage: ['이미지 제거', 'Remove image', 'Xóa ảnh', 'Удалить изображение'],
  toastIconSaved: [
    '아이콘 이미지 저장됨 (관리자 우선)',
    'Icon image saved (admin priority)',
    'Đã lưu ảnh biểu tượng (ưu tiên quản trị)',
    'Изображение иконки сохранено (приоритет админа)',
  ],
  toastUploadFail: ['업로드 실패', 'Upload failed', 'Tải lên thất bại', 'Ошибка загрузки'],
  toastAdminImageRemoved: [
    '관리자 이미지 제거됨',
    'Admin image removed',
    'Đã xóa ảnh quản trị',
    'Изображение админа удалено',
  ],
  toastDeleteFail: ['삭제 실패', 'Delete failed', 'Xóa thất bại', 'Ошибка удаления'],
  toastPreferAdminSet: [
    '관리자 이미지 우선으로 설정',
    'Set to prefer admin image',
    'Đã đặt ưu tiên ảnh quản trị',
    'Установлен приоритет изображения админа',
  ],
  toastPreferRealSet: [
    '실사진 자동 매칭 우선',
    'Prefer auto-matched real photo',
    'Ưu tiên ảnh thực tự động khớp',
    'Приоритет автоматически подобранному реальному фото',
  ],
  toastSaveFail: ['저장 실패', 'Save failed', 'Lưu thất bại', 'Ошибка сохранения'],
  toastLoadFail: ['로드 실패', 'Load failed', 'Tải thất bại', 'Ошибка загрузки'],
};

/** Shared generic labels reused across simple admin CRUD screens (scam/notice/etc). */
const adminCommon = {
  colTitle: ['제목', 'Title', 'Tiêu đề', 'Заголовок'],
  colLanguage: ['언어', 'Language', 'Ngôn ngữ', 'Язык'],
  colRegion: ['지역', 'Region', 'Khu vực', 'Регион'],
  colDate: ['날짜', 'Date', 'Ngày', 'Дата'],
  colStatus: ['상태', 'Status', 'Trạng thái', 'Статус'],
  colActions: ['작업', 'Actions', 'Thao tác', 'Действия'],
  fieldContent: ['내용', 'Content', 'Nội dung', 'Содержание'],
  edit: ['수정', 'Edit', 'Sửa', 'Изменить'],
  delete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  active: ['활성', 'Active', 'Đang bật', 'Активно'],
  inactive: ['비활성', 'Inactive', 'Đang tắt', 'Неактивно'],
  activeCheckboxLabel: ['활성화', 'Active', 'Kích hoạt', 'Активировать'],
  confirmDelete: ['삭제할까요?', 'Delete this?', 'Xóa mục này?', 'Удалить это?'],
  languageAll: ['전체', 'All', 'Tất cả', 'Все'],
  regionAll: ['전체', 'All', 'Tất cả', 'Все'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  hide: ['숨김', 'Hide', 'Ẩn', 'Скрыть'],
  emptyData: ['데이터 없음', 'No data', 'Không có dữ liệu', 'Нет данных'],
  statReported: ['신고됨', 'Reported', 'Bị báo cáo', 'С жалобами'],
  statTodayNew: ['오늘 신규', 'New today', 'Mới hôm nay', 'Новых сегодня'],
  colThumb: ['썸네일', 'Thumbnail', 'Ảnh thu nhỏ', 'Миниатюра'],
  colRating: ['평점', 'Rating', 'Đánh giá', 'Рейтинг'],
  colType: ['유형', 'Type', 'Loại', 'Тип'],
  colBookings: ['예약수', 'Bookings', 'Số lượt đặt', 'Бронирования'],
  colInquiries: ['문의수', 'Inquiries', 'Số lượt hỏi', 'Запросы'],
  statKoreanFriendly: [
    '한국어 가능',
    'Korean-friendly',
    'Hỗ trợ tiếng Hàn',
    'Говорят по-корейски',
  ],
  loadingDots: ['로딩 중...', 'Loading...', 'Đang tải...', 'Загрузка...'],
  emptyPendingCharge: [
    '대기 중인 충전 요청이 없습니다.',
    'No pending charge requests.',
    'Không có yêu cầu nạp tiền đang chờ.',
    'Нет ожидающих запросов пополнения.',
  ],
  confirmRejectChargeRequest: [
    '{name}의 충전 요청을 거절할까요?',
    'Reject the charge request from {name}?',
    'Từ chối yêu cầu nạp tiền của {name}?',
    'Отклонить запрос пополнения от {name}?',
  ],
  emptyBusinessNameParens: [
    '(업체명 없음)',
    '(No business name)',
    '(Không có tên doanh nghiệp)',
    '(Без названия бизнеса)',
  ],
};

const points = {
  pageTitle: ['💰 포인트 관리', '💰 Point management', '💰 Quản lý điểm', '💰 Управление баллами'],
  pageDesc: [
    '슈퍼 관리자만 유저 검색·포인트 지급·지급 내역 조회가 가능합니다.',
    'Only super admins can search users, grant points, and view the grant history.',
    'Chỉ super admin mới có thể tìm người dùng, cấp điểm và xem lịch sử cấp phát.',
    'Только super admin может искать пользователей, начислять баллы и просматривать историю начислений.',
  ],
  searchSectionTitle: ['유저 검색', 'Search users', 'Tìm người dùng', 'Поиск пользователей'],
  searchPlaceholder: [
    '이메일 또는 닉네임',
    'Email or nickname',
    'Email hoặc biệt danh',
    'Email или никнейм',
  ],
  searchBtn: ['검색', 'Search', 'Tìm kiếm', 'Поиск'],
  colPoints: ['포인트', 'Points', 'Điểm', 'Баллы'],
  selectBtn: ['선택', 'Select', 'Chọn', 'Выбрать'],
  emptySearchResults: [
    '검색 결과가 여기에 표시됩니다.',
    'Search results will appear here.',
    'Kết quả tìm kiếm sẽ hiển thị ở đây.',
    'Результаты поиска появятся здесь.',
  ],
  grantSectionTitle: ['지급', 'Grant', 'Cấp phát', 'Начисление'],
  selectedLabel: [
    '선택: {nickname} ({email}) — 현재 {points}',
    'Selected: {nickname} ({email}) — current {points}',
    'Đã chọn: {nickname} ({email}) — hiện tại {points}',
    'Выбрано: {nickname} ({email}) — сейчас {points}',
  ],
  noSelectionHint: [
    '검색 후 유저를 선택하세요.',
    'Search and select a user.',
    'Tìm kiếm và chọn người dùng.',
    'Найдите и выберите пользователя.',
  ],
  grantAmountLabel: ['충전 포인트 (P)', 'Points to grant (P)', 'Điểm cấp (P)', 'Начисляемые баллы (P)'],
  reasonLabel: ['사유', 'Reason', 'Lý do', 'Причина'],
  reasonPlaceholder: [
    '예: 이벤트 보상',
    'e.g. event reward',
    'VD: thưởng sự kiện',
    'напр., награда за событие',
  ],
  grantBtn: ['지급', 'Grant', 'Cấp phát', 'Начислить'],
  ledgerSectionTitle: [
    '지급 내역 (관리자 충전)',
    'Grant history (admin top-up)',
    'Lịch sử cấp phát (nạp bởi quản trị viên)',
    'История начислений (пополнение админом)',
  ],
  targetUserIdLabel: ['대상 유저 ID (선택)', 'Target user ID (optional)', 'ID người dùng mục tiêu (tùy chọn)', 'ID целевого пользователя (необязательно)'],
  targetUserIdPlaceholder: ['uuid 전체', 'full uuid', 'uuid đầy đủ', 'полный uuid'],
  filterApplyBtn: ['필터 적용', 'Apply filter', 'Áp dụng bộ lọc', 'Применить фильтр'],
  colWhen: ['일시', 'Date/time', 'Thời gian', 'Дата/время'],
  colUser: ['유저', 'User', 'Người dùng', 'Пользователь'],
  colAmount: ['금액', 'Amount', 'Số tiền', 'Сумма'],
  emptyLedger: ['내역이 없습니다.', 'No history.', 'Không có lịch sử.', 'Нет истории.'],
  errSupabaseNotConfigured: [
    'Supabase가 설정되지 않았습니다.',
    'Supabase is not configured.',
    'Supabase chưa được cấu hình.',
    'Supabase не настроен.',
  ],
  errNoSearchResults: [
    '검색 결과가 없습니다.',
    'No search results.',
    'Không có kết quả tìm kiếm.',
    'Нет результатов поиска.',
  ],
  errSearchFailed: [
    '검색에 실패했습니다. 슈퍼 관리자 권한을 확인하세요.',
    'Search failed. Check your super admin permission.',
    'Tìm kiếm thất bại. Vui lòng kiểm tra quyền super admin.',
    'Ошибка поиска. Проверьте права super admin.',
  ],
  errLedgerLoadFailed: [
    '지급 내역을 불러오지 못했습니다.',
    'Failed to load the grant history.',
    'Không thể tải lịch sử cấp phát.',
    'Не удалось загрузить историю начислений.',
  ],
  errSelectUser: ['유저를 선택하세요.', 'Please select a user.', 'Vui lòng chọn người dùng.', 'Пожалуйста, выберите пользователя.'],
  errInvalidAmount: [
    '충전 금액을 확인하세요.',
    'Please check the grant amount.',
    'Vui lòng kiểm tra số điểm cấp.',
    'Проверьте начисляемую сумму.',
  ],
  defaultGrantReason: ['관리자 충전', 'Admin top-up', 'Nạp bởi quản trị viên', 'Пополнение админом'],
  successGranted: [
    '포인트가 지급되었습니다.',
    'Points have been granted.',
    'Đã cấp điểm.',
    'Баллы начислены.',
  ],
  errGrantFailed: [
    '지급에 실패했습니다.',
    'Failed to grant points.',
    'Cấp phát thất bại.',
    'Не удалось начислить.',
  ],
};

const errorLogs = {
  pageTitle: ['🔴 에러 로그', '🔴 Error logs', '🔴 Nhật ký lỗi', '🔴 Журнал ошибок'],
  pageDesc: [
    '최근 에러 목록, 페이지별 집계, 해결 여부를 관리합니다.',
    'Manage recent error lists, per-page counts, and resolved status.',
    'Quản lý danh sách lỗi gần đây, tổng hợp theo trang và trạng thái xử lý.',
    'Управление списком последних ошибок, статистикой по страницам и статусом решения.',
  ],
  filterSectionTitle: ['필터', 'Filters', 'Bộ lọc', 'Фильтры'],
  userIdLabel: ['유저 ID', 'User ID', 'ID người dùng', 'ID пользователя'],
  unresolvedOnlyLabel: ['미해결만', 'Unresolved only', 'Chỉ chưa xử lý', 'Только нерешённые'],
  queryBtn: ['조회', 'Query', 'Truy vấn', 'Запрос'],
  byPageSectionTitle: [
    '페이지별 에러 수 (많은 순)',
    'Errors by page (most first)',
    'Số lỗi theo trang (nhiều nhất trước)',
    'Ошибки по страницам (по убыванию)',
  ],
  colPage: ['페이지', 'Page', 'Trang', 'Страница'],
  colCount: ['건수', 'Count', 'Số lượng', 'Количество'],
  recentSectionTitle: ['최근 에러 목록', 'Recent errors', 'Danh sách lỗi gần đây', 'Последние ошибки'],
  colPageAction: ['페이지/액션', 'Page/Action', 'Trang/Hành động', 'Страница/Действие'],
  colMessage: ['메시지', 'Message', 'Thông báo', 'Сообщение'],
  emptyErrors: ['에러가 없습니다.', 'No errors.', 'Không có lỗi.', 'Нет ошибок.'],
  statusResolved: ['해결됨', 'Resolved', 'Đã xử lý', 'Решено'],
  statusUnresolved: ['미해결', 'Unresolved', 'Chưa xử lý', 'Не решено'],
  detailBtn: ['상세', 'Details', 'Chi tiết', 'Подробнее'],
  markUnresolvedBtn: ['미해결로', 'Mark unresolved', 'Đánh dấu chưa xử lý', 'Отметить нерешённым'],
  detailSectionTitle: ['에러 상세', 'Error details', 'Chi tiết lỗi', 'Подробности ошибки'],
  errLoadFailed: [
    '에러 로그를 불러오지 못했습니다.',
    'Failed to load error logs.',
    'Không thể tải nhật ký lỗi.',
    'Не удалось загрузить журнал ошибок.',
  ],
  errStatusChangeFailed: [
    '상태 변경에 실패했습니다.',
    'Failed to change the status.',
    'Thay đổi trạng thái thất bại.',
    'Не удалось изменить статус.',
  ],
};

const systemOps = {
  pageTitle: [
    '시스템 · 플래그 · 웹훅',
    'System · Flags · Webhooks',
    'Hệ thống · Cờ tính năng · Webhook',
    'Система · Флаги · Вебхуки',
  ],
  superAdminOnlyWarn: [
    'feature_flags 토글은 super_admin만 가능합니다. 목록은 조회만 됩니다.',
    'Only super_admin can toggle feature_flags. The list is view-only.',
    'Chỉ super_admin mới có thể bật/tắt feature_flags. Danh sách chỉ để xem.',
    'Только super_admin может переключать feature_flags. Список доступен только для просмотра.',
  ],
  superAdminOnlyErrorMsg: [
    'feature_flags 토글은 super_admin만 가능합니다.',
    'Only super_admin can toggle feature_flags.',
    'Chỉ super_admin mới có thể bật/tắt feature_flags.',
    'Только super_admin может переключать feature_flags.',
  ],
  webhooksSectionTitle: [
    'payment_webhooks (미처리)',
    'payment_webhooks (unprocessed)',
    'payment_webhooks (chưa xử lý)',
    'payment_webhooks (необработано)',
  ],
  emptyWebhooks: [
    '미처리 웹훅 없음',
    'No unprocessed webhooks',
    'Không có webhook chưa xử lý',
    'Нет необработанных вебхуков',
  ],
};

const catalogApproval = {
  pageDesc: [
    '업체가 게시한 catalog_items를 검수합니다. 승인 시 유저 화면에 노출됩니다.',
    'Reviews catalog_items posted by businesses. Approving makes them visible to users.',
    'Xem xét catalog_items do doanh nghiệp đăng. Khi duyệt sẽ hiển thị cho người dùng.',
    'Проверка catalog_items, размещённых бизнесом. При одобрении становится видно пользователям.',
  ],
  tabHidden: ['반려·숨김', 'Rejected/Hidden', 'Bị từ chối/Ẩn', 'Отклонено/Скрыто'],
  tabDraft: ['임시저장', 'Draft', 'Bản nháp', 'Черновик'],
  typeFilterAll: ['전체 유형', 'All types', 'Tất cả loại', 'Все типы'],
  bizCategoryAll: ['전체 업종', 'All categories', 'Tất cả danh mục', 'Все категории'],
  emptyList: [
    '해당 조건의 상품이 없습니다.',
    'No products match these filters.',
    'Không có sản phẩm phù hợp với bộ lọc này.',
    'Нет товаров по этим фильтрам.',
  ],
  emptyTitle: ['(제목 없음)', '(No title)', '(Không có tiêu đề)', '(Без названия)'],
  businessLabel: ['업체: {name}', 'Business: {name}', 'Doanh nghiệp: {name}', 'Бизнес: {name}'],
  priceUndecided: [
    '가격 미정',
    'Price TBD',
    'Giá chưa xác định',
    'Цена не определена',
  ],
  comboComponentsLabel: ['포함 서비스', 'Included services', 'Dịch vụ bao gồm', 'Включённые услуги'],
  rejectPrompt: [
    '반려 사유 (선택)',
    'Rejection reason (optional)',
    'Lý do từ chối (tùy chọn)',
    'Причина отклонения (необязательно)',
  ],
};

const businessClaims = {
  pageTitle: ['가게 클레임 승인', 'Business claim approval', 'Duyệt yêu cầu xác nhận cửa hàng', 'Одобрение заявок на владение бизнесом'],
  pageDesc: [
    '사장님 없이 등록된 예시 업체를 실제 사장님이 "내 가게예요"로 신청한 목록입니다. 승인하면 해당 계정이 업체 소유자로 연결됩니다.',
    'A list of sample businesses (registered without an owner) that a real owner has claimed as "This is my business." Approving links that account as the business owner.',
    'Danh sách các doanh nghiệp mẫu (đăng ký không có chủ) mà chủ thực sự đã yêu cầu xác nhận là "Đây là cửa hàng của tôi". Khi duyệt, tài khoản đó sẽ được liên kết làm chủ doanh nghiệp.',
    'Список примерных бизнесов (зарегистрированных без владельца), которые реальный владелец заявил как "Это мой бизнес". При одобрении аккаунт привязывается как владелец бизнеса.',
  ],
  colBusiness: ['업체', 'Business', 'Doanh nghiệp', 'Бизнес'],
  colAddress: ['주소', 'Address', 'Địa chỉ', 'Адрес'],
  colContact: ['연락처', 'Contact', 'Liên hệ', 'Контакт'],
  colNote: ['메모', 'Note', 'Ghi chú', 'Заметка'],
  colAppliedDate: ['신청일', 'Applied date', 'Ngày yêu cầu', 'Дата заявки'],
  colRejectReason: ['거절 사유', 'Rejection reason', 'Lý do từ chối', 'Причина отклонения'],
  colActions: ['처리', 'Action', 'Xử lý', 'Действие'],
  errProcessFailed: ['처리 실패', 'Processing failed', 'Xử lý thất bại', 'Ошибка обработки'],
  emptyList: [
    '대기중인 클레임 요청이 없습니다.',
    'No pending claim requests.',
    'Không có yêu cầu xác nhận đang chờ.',
    'Нет ожидающих заявок.',
  ],
};

const bizChargeRequests = {
  pageTitle: [
    '🏢 업체 크레딧 충전 요청',
    '🏢 Business credit charge requests',
    '🏢 Yêu cầu nạp tín dụng doanh nghiệp',
    '🏢 Запросы пополнения кредитов бизнеса',
  ],
  pageDesc: [
    '업체가 무통장입금 후 접수한 밍고크레딧 충전 요청이에요. 입금 확인 후 승인하면 즉시 크레딧이 지급돼요.',
    'Mingo credit top-up requests submitted by businesses after a bank transfer. Approving after confirming the deposit issues credits immediately.',
    'Yêu cầu nạp tín dụng Mingo được doanh nghiệp gửi sau khi chuyển khoản. Sau khi xác nhận đã nhận tiền và duyệt, tín dụng sẽ được cấp ngay.',
    'Запросы на пополнение кредитов Mingo, отправленные бизнесом после банковского перевода. После подтверждения платежа и одобрения кредиты начисляются немедленно.',
  ],
  confirmApprove: [
    '{name}에 {credits}크레딧 지급할까요?',
    'Give {credits} credits to {name}?',
    'Cấp {credits} tín dụng cho {name}?',
    'Начислить {credits} кредитов для {name}?',
  ],
  defaultBusinessName: ['업체', 'Business', 'Doanh nghiệp', 'Бизнес'],
  noteLabel: [
    '입금자명/메모:',
    'Depositor name/note:',
    'Tên người gửi/ghi chú:',
    'Имя вкладчика/заметка:',
  ],
  creditsLabel: ['+{amount} 크레딧', '+{amount} credits', '+{amount} tín dụng', '+{amount} кредитов'],
  btnApprove: [
    '입금확인 · 승인',
    'Confirm deposit · Approve',
    'Xác nhận nạp · Duyệt',
    'Подтвердить платёж · Одобрить',
  ],
  errApproveFailed: [
    '승인 처리 중 오류가 발생했어요.',
    'An error occurred while approving.',
    'Đã xảy ra lỗi khi duyệt.',
    'Произошла ошибка при одобрении.',
  ],
  errRejectFailed: [
    '거절 처리 중 오류가 발생했어요.',
    'An error occurred while rejecting.',
    'Đã xảy ra lỗi khi từ chối.',
    'Произошла ошибка при отклонении.',
  ],
};

const chargeRequests = {
  pageTitle: ['🪙 포인트 충전 요청', '🪙 Point top-up requests', '🪙 Yêu cầu nạp điểm', '🪙 Запросы пополнения баллов'],
  confirmApprovePoints: [
    '{name}에게 {points}P 지급할까요?',
    'Give {points}P to {name}?',
    'Cấp {points}P cho {name}?',
    'Начислить {points}P для {name}?',
  ],
  approveNote: [
    '충전 요청 승인 (요청ID: {id})',
    'Charge request approved (request ID: {id})',
    'Đã duyệt yêu cầu nạp tiền (ID yêu cầu: {id})',
    'Одобрен запрос пополнения (ID запроса: {id})',
  ],
  pointsLabel: ['+{amount}P', '+{amount}P', '+{amount}P', '+{amount}P'],
};

const users = {
  pageTitle: ['유저 관리', 'User management', 'Quản lý người dùng', 'Управление пользователями'],
  searchPlaceholder: [
    '닉네임 / 이메일 검색',
    'Search nickname / email',
    'Tìm biệt danh / email',
    'Поиск по нику / email',
  ],
  colNickname: ['닉네임', 'Nickname', 'Biệt danh', 'Никнейм'],
  colEmail: ['이메일', 'Email', 'Địa chỉ email', 'Электронная почта'],
  colJoinDate: ['가입일', 'Join date', 'Ngày tham gia', 'Дата регистрации'],
  colActivityScore: ['활동지수%', 'Activity score%', 'Điểm hoạt động%', 'Индекс активности%'],
  colNoShowCount: ['노쇼 횟수', 'No-show count', 'Số lần bỏ hẹn', 'Количество неявок'],
  statusBlocked: ['차단', 'Blocked', 'Bị chặn', 'Заблокирован'],
  statusOk: ['정상', 'Normal', 'Bình thường', 'В норме'],
  btnSanction: ['제재', 'Sanction', 'Xử phạt', 'Санкция'],
  btnUnsanction: ['제재 해제', 'Remove sanction', 'Gỡ xử phạt', 'Снять санкцию'],
};

const subscriptions = {
  pageTitle: ['💎 구독 플랜 관리', '💎 Subscription plan management', '💎 Quản lý gói đăng ký', '💎 Управление подписками'],
  statTotal: ['전체 구독', 'Total subscriptions', 'Tổng gói đăng ký', 'Всего подписок'],
  statMonthlyRevenue: [
    '월 예상 수익',
    'Est. monthly revenue',
    'Doanh thu ước tính hàng tháng',
    'Прогноз ежемесячного дохода',
  ],
  statBasic: ['베이직', 'Basic', 'Cơ bản', 'Базовый'],
  statPremium: ['프리미엄', 'Premium', 'Cao cấp', 'Премиум'],
  planFree: ['무료', 'Free', 'Miễn phí', 'Бесплатно'],
  planBasic: ['베이직 $19', 'Basic $19', 'Cơ bản $19', 'Базовый $19'],
  planPremium: ['프리미엄 $49', 'Premium $49', 'Cao cấp $49', 'Премиум $49'],
  emptyList: [
    '구독 내역이 없습니다.',
    'No subscription history.',
    'Không có lịch sử đăng ký.',
    'Нет истории подписок.',
  ],
  emptyBusinessName: ['업체명 없음', 'No business name', 'Không có tên doanh nghiệp', 'Без названия бизнеса'],
  statusActive: ['✅ 활성', '✅ Active', '✅ Đang hoạt động', '✅ Активна'],
};

const shortsQueue = {
  pageTitle: ['🎬 AI 쇼츠 큐 관리', '🎬 AI Shorts queue management', '🎬 Quản lý hàng đợi Shorts AI', '🎬 Управление очередью AI Shorts'],
  filterPending: ['⏳ 대기', '⏳ Pending', '⏳ Đang chờ', '⏳ Ожидание'],
  filterProcessing: ['⚙️ 처리중', '⚙️ Processing', '⚙️ Đang xử lý', '⚙️ Обработка'],
  filterCompleted: ['✅ 완료', '✅ Completed', '✅ Hoàn thành', '✅ Завершено'],
  filterFailed: ['❌ 실패', '❌ Failed', '❌ Thất bại', '❌ Ошибка'],
  emptyList: ['항목이 없습니다.', 'No items.', 'Không có mục nào.', 'Нет элементов.'],
  btnStartProcessing: ['처리 시작', 'Start processing', 'Bắt đầu xử lý', 'Начать обработку'],
  btnComplete: ['완료 처리', 'Mark completed', 'Đánh dấu hoàn thành', 'Отметить как завершённое'],
};

const businessVerify = {
  pageTitle: ['업체 인증 관리', 'Business verification management', 'Quản lý xác minh doanh nghiệp', 'Управление верификацией бизнеса'],
  colLicense: ['등록증', 'License', 'Giấy phép', 'Лицензия'],
  colGrade: ['인증 등급', 'Verification grade', 'Cấp độ xác minh', 'Уровень верификации'],
  viewImageLink: ['이미지 보기', 'View image', 'Xem ảnh', 'Просмотреть изображение'],
};

const login = {
  hint: [
    'Staff 로그인: Supabase 계정 이메일·비밀번호. 도시 관리자는 담당 도시만 표시됩니다.',
    'Staff login: Supabase account email/password. City admins only see their managed city.',
    'Đăng nhập nhân viên: email/mật khẩu tài khoản Supabase. Quản trị viên thành phố chỉ thấy thành phố mình phụ trách.',
    'Вход для персонала: email/пароль аккаунта Supabase. Городские админы видят только свой город.',
  ],
  lockedError: [
    '로그인이 잠겼습니다. 남은 시간: {remain}',
    'Login is locked. Time remaining: {remain}',
    'Đăng nhập đã bị khóa. Thời gian còn lại: {remain}',
    'Вход заблокирован. Осталось времени: {remain}',
  ],
  lockedSubmitError: [
    '잠금 중입니다. {remain} 후 다시 시도하세요.',
    'Locked. Try again in {remain}.',
    'Đang bị khóa. Vui lòng thử lại sau {remain}.',
    'Заблокировано. Повторите попытку через {remain}.',
  ],
  errNoEmailOrSupabase: [
    'Supabase 관리자 계정 이메일·비밀번호로 로그인해 주세요.',
    'Please log in with your Supabase admin account email and password.',
    'Vui lòng đăng nhập bằng email/mật khẩu tài khoản quản trị Supabase.',
    'Пожалуйста, войдите с email/паролем администратора Supabase.',
  ],
  errSignInFailed: ['로그인에 실패했습니다.', 'Login failed.', 'Đăng nhập thất bại.', 'Не удалось войти.'],
  errNoAdminPermission: [
    '관리자 권한이 없습니다.',
    'No admin permission.',
    'Không có quyền quản trị.',
    'Нет прав администратора.',
  ],
  errNoAdminRole: [
    'admin_role이 설정되지 않았습니다. 접근이 거부되었습니다.',
    'admin_role is not set. Access denied.',
    'Chưa thiết lập admin_role. Truy cập bị từ chối.',
    'admin_role не задана. Доступ запрещён.',
  ],
  errNoManagedCity: [
    '도시 관리자에게 담당 도시(managed_city)가 없습니다.',
    'This city admin has no managed city (managed_city).',
    'Quản trị viên thành phố này không có thành phố phụ trách (managed_city).',
    'У этого городского админа не задан управляемый город (managed_city).',
  ],
  emailPlaceholder: [
    '관리자 이메일 (Staff)',
    'Admin email (Staff)',
    'Email quản trị viên (Staff)',
    'Email администратора (Staff)',
  ],
  passwordPlaceholder: ['비밀번호', 'Password', 'Mật khẩu', 'Пароль'],
  submitBtn: ['로그인', 'Log in', 'Đăng nhập', 'Войти'],
};

const adInquiries = {
  pageDesc: [
    '앱에서 접수된 광고 문의입니다 (포인트 결제·일반 문의 포함).',
    'Ad inquiries submitted from the app (including point-paid requests).',
    'Yêu cầu quảng cáo được gửi từ ứng dụng (bao gồm cả yêu cầu trả bằng điểm).',
    'Запросы на рекламу из приложения (включая оплаченные баллами).',
  ],
  emptyList: [
    '접수된 문의가 없습니다.',
    'No inquiries received.',
    'Không có yêu cầu nào được gửi.',
    'Нет полученных запросов.',
  ],
  loading: ['불러오는 중...', 'Loading...', 'Đang tải...', 'Загрузка...'],
  loadFail: [
    '불러오기에 실패했습니다.',
    'Failed to load.',
    'Không tải được.',
    'Не удалось загрузить.',
  ],
  pointsChargedLabel: [
    '차감 포인트: {pts} P',
    'Points charged: {pts} P',
    'Điểm đã trừ: {pts} P',
    'Списано баллов: {pts} P',
  ],
  statusNew: ['신규', 'New', 'Mới', 'Новый'],
  statusContacted: ['연락함', 'Contacted', 'Đã liên hệ', 'Связались'],
  statusClosed: ['종료', 'Closed', 'Đã đóng', 'Закрыт'],
  statusPaid: ['결제완료(카드)', 'Paid (card)', 'Đã thanh toán (thẻ)', 'Оплачено (карта)'],
  markContacted: ['연락함으로 표시', 'Mark contacted', 'Đánh dấu đã liên hệ', 'Отметить как связались'],
  markClosed: ['종료 처리', 'Mark closed', 'Đánh dấu đã đóng', 'Отметить как закрыт'],
};

const travelQuotes = {
  pageDesc: [
    '여행 진입허브(자유여행·패키지 맞춤 상담)에서 접수된 견적문의입니다.',
    'Quote requests submitted from the travel entry hub (independent travel / package consultation).',
    'Yêu cầu báo giá được gửi từ trung tâm du lịch (tự túc / trọn gói).',
    'Запросы на тур, отправленные из раздела путешествий (самостоятельное/пакетное).',
  ],
  loading: ['불러오는 중...', 'Loading...', 'Đang tải...', 'Загрузка...'],
  loadFail: [
    '불러오기에 실패했습니다.',
    'Failed to load.',
    'Không tải được.',
    'Не удалось загрузить.',
  ],
  emptyList: [
    '접수된 견적문의가 없습니다.',
    'No quote requests received.',
    'Không có yêu cầu báo giá nào.',
    'Нет полученных запросов на тур.',
  ],
  statusPending: ['대기', 'Pending', 'Đang chờ', 'В ожидании'],
  statusContacted: ['연락중', 'Contacted', 'Đã liên hệ', 'Связались'],
  statusClosed: ['완료', 'Closed', 'Đã hoàn tất', 'Завершено'],
  markContacted: [
    '연락중으로 표시',
    'Mark contacted',
    'Đánh dấu đã liên hệ',
    'Отметить как связались',
  ],
  markClosed: ['완료 처리', 'Mark closed', 'Đánh dấu hoàn tất', 'Отметить как завершено'],
  destinationLabel: ['목적지', 'Destination', 'Điểm đến', 'Направление'],
  headcountLabel: ['인원', 'Headcount', 'Số người', 'Количество человек'],
  headcountValue: [
    '성인 {a} · 아동 {c} · 유아 {i}',
    '{a} adults · {c} children · {i} infants',
    '{a} người lớn · {c} trẻ em · {i} em bé',
    '{a} взр. · {c} дет. · {i} млад.',
  ],
  purposeLabel: ['여행목적', 'Purpose', 'Mục đích', 'Цель поездки'],
  budgetLabel: ['예산대', 'Budget', 'Ngân sách', 'Бюджет'],
  datesLabel: ['희망일정', 'Preferred dates', 'Lịch trình mong muốn', 'Желаемые даты'],
  hotelGradeLabel: ['숙소등급', 'Hotel grade', 'Hạng khách sạn', 'Категория отеля'],
  roomTypeLabel: ['객실타입', 'Room type', 'Loại phòng', 'Тип номера'],
  mealPlanLabel: ['식사포함', 'Meals', 'Bữa ăn', 'Питание'],
  flightLabel: ['항공권', 'Flight', 'Vé máy bay', 'Авиабилет'],
  activitiesLabel: ['희망활동', 'Activities', 'Hoạt động', 'Активности'],
  noteLabel: ['메모', 'Note', 'Ghi chú', 'Заметка'],
  contactLabel: ['연락처', 'Contact', 'Liên hệ', 'Контакт'],
  userLabel: ['신청자', 'Requested by', 'Người yêu cầu', 'Заявитель'],
  tripTypeFree: [
    '자유여행·패키지 상담',
    'Independent/package consult',
    'Tư vấn tự túc/trọn gói',
    'Консультация (самост./пакет)',
  ],
  tripTypeUnsure: ['미정', 'Undecided', 'Chưa quyết định', 'Не определено'],
};

const visaServices = {
  pageDesc: [
    '업체 승인·숨김·삭제',
    'Approve, hide, or delete listings',
    'Duyệt, ẩn hoặc xóa danh sách',
    'Одобрение, скрытие или удаление объявлений',
  ],
  statTotal: ['전체 업체', 'Total businesses', 'Tổng doanh nghiệp', 'Всего бизнесов'],
  statVerified: ['인증업체', 'Verified', 'Đã xác minh', 'Верифицировано'],
  colBusinessName: ['업체명', 'Business name', 'Tên doanh nghiệp', 'Название бизнеса'],
  colServiceType: ['서비스유형', 'Service type', 'Loại dịch vụ', 'Тип услуги'],
  colProcessingTime: [
    '처리기간',
    'Processing time',
    'Thời gian xử lý',
    'Срок обработки',
  ],
  colPrice: ['가격', 'Price', 'Giá', 'Цена'],
  confirmDeleteListing: [
    '이 비자 서비스 등록을 삭제할까요?',
    'Delete this visa service listing?',
    'Xóa danh sách dịch vụ visa này?',
    'Удалить это объявление о визовой услуге?',
  ],
  daysRange: ['{a}~{b}일', '{a}–{b} days', '{a}–{b} ngày', '{a}–{b} дн.'],
};

const hospitals = {
  pageDesc: [
    '네이버예약 / 카카오헬스 스타일',
    'Naver Reservations / Kakao Health style',
    'Phong cách Naver Reservations / Kakao Health',
    'В стиле Naver Reservations / Kakao Health',
  ],
  statTotal: ['전체 병원', 'Total hospitals', 'Tổng bệnh viện', 'Всего больниц'],
  statEmergency: ['응급실', 'Emergency room', 'Phòng cấp cứu', 'Скорая помощь'],
  colHospitalName: ['병원명', 'Hospital name', 'Tên bệnh viện', 'Название больницы'],
  colSpecialties: ['진료과', 'Specialties', 'Chuyên khoa', 'Специализации'],
  colKorean: ['한국어', 'Korean', 'Tiếng Hàn', 'Корейский'],
  confirmDeleteListing: [
    '이 병원 등록을 삭제할까요?',
    'Delete this hospital listing?',
    'Xóa danh sách bệnh viện này?',
    'Удалить это объявление о больнице?',
  ],
};

const rentals = {
  pageDesc: [
    'Turo 스타일 차량/오토바이',
    'Turo-style cars/motorbikes',
    'Phong cách Turo cho ô tô/xe máy',
    'В стиле Turo для авто/мотоциклов',
  ],
  statTotal: ['전체 차량', 'Total vehicles', 'Tổng phương tiện', 'Всего транспорта'],
  statAvailable: ['이용가능', 'Available', 'Có sẵn', 'Доступно'],
  statBooked: ['예약중', 'Booked', 'Đã đặt', 'Забронировано'],
  colImage: ['이미지', 'Image', 'Hình ảnh', 'Изображение'],
  colVehicle: ['차량', 'Vehicle', 'Phương tiện', 'Транспорт'],
  colPricePerDay: ['가격/일', 'Price/day', 'Giá/ngày', 'Цена/день'],
  colHost: ['호스트', 'Host', 'Chủ xe', 'Хозяин'],
  colRegisteredDate: ['등록일', 'Registered', 'Ngày đăng', 'Дата регистрации'],
  confirmDeleteListing: [
    '이 등록을 삭제할까요?',
    'Delete this listing?',
    'Xóa danh sách này?',
    'Удалить это объявление?',
  ],
};

const academies = {
  pageDesc: [
    '클래스101 / 숨고 스타일 학원 노출·승인',
    'Class101 / Soomgo-style academy listing & approval',
    'Phong cách Class101 / Soomgo cho hiển thị & duyệt trung tâm học',
    'В стиле Class101 / Soomgo для показа и одобрения курсов',
  ],
  statTotal: ['전체 학원', 'Total academies', 'Tổng trung tâm học', 'Всего курсов'],
  statOnline: ['온라인 가능', 'Online available', 'Có học online', 'Доступно онлайн'],
  statVerified: [
    '인증 학원',
    'Verified academies',
    'Trung tâm đã xác minh',
    'Верифицированные курсы',
  ],
  colAcademyName: ['학원명', 'Academy name', 'Tên trung tâm', 'Название курсов'],
  colClassLanguage: ['수업언어', 'Class language', 'Ngôn ngữ lớp học', 'Язык обучения'],
  confirmDeleteAcademy: [
    '이 학원을 삭제할까요?',
    'Delete this academy?',
    'Xóa trung tâm học này?',
    'Удалить эти курсы?',
  ],
};

const restaurants = {
  pageDesc: [
    '망고플레이트·배민 스타일 식당 승인·노출',
    'Mangoplate/Baemin-style restaurant approval & listing',
    'Phong cách Mangoplate/Baemin cho duyệt & hiển thị nhà hàng',
    'В стиле Mangoplate/Baemin для одобрения и показа ресторанов',
  ],
  statTotal: ['전체 식당', 'Total restaurants', 'Tổng nhà hàng', 'Всего ресторанов'],
  statDelivery: ['배달가능', 'Delivery available', 'Có giao hàng', 'Есть доставка'],
  colRestaurantName: ['식당명', 'Restaurant name', 'Tên nhà hàng', 'Название ресторана'],
  colPriceRange: ['가격대', 'Price range', 'Khoảng giá', 'Ценовой диапазон'],
  colReviews: ['리뷰', 'Reviews', 'Đánh giá', 'Отзывы'],
  confirmDeleteRestaurant: [
    '이 식당을 삭제할까요?',
    'Delete this restaurant?',
    'Xóa nhà hàng này?',
    'Удалить этот ресторан?',
  ],
};

const hotels = {
  pageDesc: [
    '승인·숨김·삭제 (관리자 전용)',
    'Approve, hide, or delete (admin only)',
    'Duyệt, ẩn hoặc xóa (chỉ dành cho quản trị viên)',
    'Одобрение, скрытие или удаление (только для админа)',
  ],
  statTotal: ['전체 호텔', 'Total hotels', 'Tổng khách sạn', 'Всего отелей'],
  statPending: ['승인 대기', 'Pending approval', 'Chờ duyệt', 'Ожидает одобрения'],
  colName: ['이름', 'Name', 'Tên', 'Название'],
  colCity: ['도시', 'City', 'Thành phố', 'Город'],
  colReview: ['검수', 'Review', 'Kiểm duyệt', 'Проверка'],
  colExposure: ['노출', 'Exposure', 'Hiển thị', 'Показ'],
  colReported: ['신고', 'Reported', 'Báo cáo', 'Жалобы'],
  confirmDeleteHotel: [
    '이 호텔을 삭제할까요?',
    'Delete this hotel?',
    'Xóa khách sạn này?',
    'Удалить этот отель?',
  ],
  emptyHotels: ['호텔이 없습니다.', 'No hotels.', 'Không có khách sạn.', 'Нет отелей.'],
};

const notice = {
  addBtn: ['공지 추가', 'Add notice', 'Thêm thông báo', 'Добавить объявление'],
  modalTitleEdit: [
    '공지 수정',
    'Edit notice',
    'Sửa thông báo',
    'Изменить объявление',
  ],
  fieldStartDate: ['시작일', 'Start date', 'Ngày bắt đầu', 'Дата начала'],
  fieldEndDate: ['종료일', 'End date', 'Ngày kết thúc', 'Дата окончания'],
};

const scam = {
  title: [
    '사기 경고 (Supabase)',
    'Scam alerts (Supabase)',
    'Cảnh báo lừa đảo (Supabase)',
    'Предупреждения о мошенничестве (Supabase)',
  ],
  addBtn: ['경고 추가', 'Add alert', 'Thêm cảnh báo', 'Добавить предупреждение'],
  errSupabaseNotConfigured: [
    'Supabase 미설정',
    'Supabase not configured',
    'Supabase chưa được cấu hình',
    'Supabase не настроен',
  ],
  colRegion: ['지역', 'Region', 'Khu vực', 'Регион'],
  colTitle: ['제목', 'Title', 'Tiêu đề', 'Заголовок'],
  colSeverity: ['심각도', 'Severity', 'Mức độ nghiêm trọng', 'Серьёзность'],
  colStatus: ['상태', 'Status', 'Trạng thái', 'Статус'],
  colActions: ['작업', 'Actions', 'Thao tác', 'Действия'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  active: ['활성', 'Active', 'Đang bật', 'Активно'],
  inactive: ['비활성', 'Inactive', 'Đang tắt', 'Неактивно'],
  edit: ['수정', 'Edit', 'Sửa', 'Изменить'],
  delete: ['삭제', 'Delete', 'Xóa', 'Удалить'],
  modalTitleEdit: ['경고 수정', 'Edit alert', 'Sửa cảnh báo', 'Изменить предупреждение'],
  fieldContent: ['내용', 'Content', 'Nội dung', 'Содержание'],
  fieldLinkUrl: [
    '자세히 링크 (선택)',
    'Details link (optional)',
    'Liên kết chi tiết (tùy chọn)',
    'Ссылка с подробностями (необязательно)',
  ],
  fieldLanguage: ['언어', 'Language', 'Ngôn ngữ', 'Язык'],
  severityLow: ['낮음', 'Low', 'Thấp', 'Низкая'],
  severityMedium: ['중간', 'Medium', 'Trung bình', 'Средняя'],
  severityHigh: ['높음', 'High', 'Cao', 'Высокая'],
  languageAll: ['전체', 'All', 'Tất cả', 'Все'],
  activeCheckboxLabel: ['활성화', 'Active', 'Kích hoạt', 'Активировать'],
  cancel: ['취소', 'Cancel', 'Hủy', 'Отмена'],
  save: ['저장', 'Save', 'Lưu', 'Сохранить'],
  closeAria: ['닫기', 'Close', 'Đóng', 'Закрыть'],
  confirmDelete: ['삭제할까요?', 'Delete this?', 'Xóa mục này?', 'Удалить это?'],
  regionDanang: [
    '동네(다낭권)',
    'Neighborhood (Da Nang area)',
    'Khu vực lân cận (vùng Đà Nẵng)',
    'Район (зона Дананга)',
  ],
  regionVietnam: ['베트남', 'Vietnam', 'Việt Nam', 'Вьетнам'],
  regionGlobal: ['글로벌', 'Global', 'Toàn cầu', 'Глобально'],
  managedCityOption: [
    '담당 도시 ({city})',
    'Managed city ({city})',
    'Thành phố phụ trách ({city})',
    'Управляемый город ({city})',
  ],
};

const ads = {
  campaignStatusActive: ['진행중', 'In progress', 'Đang chạy', 'В процессе'],
  campaignStatusPaused: ['일시정지', 'Paused', 'Tạm dừng', 'Приостановлено'],
  campaignStatusCompleted: ['완료', 'Completed', 'Hoàn thành', 'Завершено'],
  campaignStatusCancelled: ['취소', 'Cancelled', 'Đã hủy', 'Отменено'],
  actionPause: ['일시정지', 'Pause', 'Tạm dừng', 'Приостановить'],
  actionResume: ['재개', 'Resume', 'Tiếp tục', 'Возобновить'],
  actionCancel: ['취소', 'Cancel', 'Hủy', 'Отменить'],
  filterAll: ['전체', 'All', 'Tất cả', 'Все'],
  sectionTitle: [
    '통합 광고엔진 캠페인 (ad_campaigns)',
    'Unified ad engine campaigns (ad_campaigns)',
    'Chiến dịch động cơ quảng cáo hợp nhất (ad_campaigns)',
    'Кампании единого рекламного движка (ad_campaigns)',
  ],
  sectionDesc: [
    '카테고리 상단슬롯/홈·화면 CPM/검색 CPC 등 업체 자가결제 캠페인 전체입니다. 자가결제라 관리자 승인 없이 바로 활성화되지만, 부적절한 캠페인은 여기서 일시정지/취소할 수 있어요.',
    "All business self-service campaigns: category top slot, home/screen CPM, search CPC, and more. Since it's self-service, campaigns activate immediately without admin approval — but you can pause or cancel inappropriate ones here.",
    'Tất cả chiến dịch tự thanh toán của doanh nghiệp: slot đầu danh mục, CPM trang chủ/màn hình, CPC tìm kiếm, v.v. Vì là tự thanh toán nên kích hoạt ngay không cần duyệt, nhưng bạn có thể tạm dừng/hủy chiến dịch không phù hợp ở đây.',
    'Все кампании самообслуживания бизнеса: верхний слот категории, CPM на главной/экранах, CPC в поиске и т.д. Поскольку это самообслуживание, кампании активируются сразу без одобрения админа — но здесь можно приостановить или отменить неподходящие.',
  ],
  noPermission: [
    '이 계정에는 광고 캠페인 관리 권한(ad.campaign.manage)이 없습니다. super_admin에게 권한 부여를 요청하세요.',
    "This account doesn't have ad campaign management permission (ad.campaign.manage). Ask a super_admin to grant it.",
    'Tài khoản này không có quyền quản lý chiến dịch quảng cáo (ad.campaign.manage). Hãy nhờ super_admin cấp quyền.',
    'У этой учётной записи нет прав на управление рекламными кампаниями (ad.campaign.manage). Попросите super_admin выдать права.',
  ],
  loading: ['로딩 중...', 'Loading…', 'Đang tải…', 'Загрузка…'],
  noCampaignsForStatus: [
    '해당 상태의 캠페인이 없습니다.',
    'No campaigns with this status.',
    'Không có chiến dịch ở trạng thái này.',
    'Нет кампаний с этим статусом.',
  ],
  budgetLabel: [
    '예산 {spent}/{budget} 크레딧',
    'Budget {spent}/{budget} credits',
    'Ngân sách {spent}/{budget} tín dụng',
    'Бюджет {spent}/{budget} кредитов',
  ],
  statusLabel: ['상태: {status}', 'Status: {status}', 'Trạng thái: {status}', 'Статус: {status}'],
  pageTitle: [
    '광고 관리 (Supabase)',
    'Ad management (Supabase)',
    'Quản lý quảng cáo (Supabase)',
    'Управление рекламой (Supabase)',
  ],
  legacyStatsTitle: [
    '레거시 업체 광고(business_ads) 성과 통계',
    'Legacy business ads (business_ads) performance stats',
    'Thống kê hiệu suất quảng cáo cũ (business_ads)',
    'Статистика старой рекламы бизнеса (business_ads)',
  ],
  impressionsLabel: ['노출수', 'Impressions', 'Lượt hiển thị', 'Показы'],
  clicksLabel: ['클릭수', 'Clicks', 'Lượt nhấp', 'Клики'],
  ctrLabel: ['클릭률', 'CTR', 'Tỷ lệ nhấp', 'Кликабельность'],
  pendingSectionTitle: [
    '승인 대기 광고',
    'Ads pending approval',
    'Quảng cáo chờ duyệt',
    'Реклама на рассмотрении',
  ],
  noPendingItems: [
    '승인 대기 항목이 없습니다.',
    'No items pending approval.',
    'Không có mục chờ duyệt.',
    'Нет элементов на рассмотрении.',
  ],
  budgetSimple: ['예산: {budget}', 'Budget: {budget}', 'Ngân sách: {budget}', 'Бюджет: {budget}'],
  approve: ['승인', 'Approve', 'Duyệt', 'Одобрить'],
  reject: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  historyTitle: [
    '업체별 광고 이력',
    'Ad history by business',
    'Lịch sử quảng cáo theo doanh nghiệp',
    'История рекламы по бизнесу',
  ],
  noHistory: ['이력이 없습니다.', 'No history.', 'Không có lịch sử.', 'Нет истории.'],
  businessLabel: ['업체: {id}', 'Business: {id}', 'Doanh nghiệp: {id}', 'Бизнес: {id}'],
  historyLine: [
    '상태: {status} · 노출 {impressions} / 클릭 {clicks}',
    'Status: {status} · Impressions {impressions} / Clicks {clicks}',
    'Trạng thái: {status} · Lượt hiển thị {impressions} / Lượt nhấp {clicks}',
    'Статус: {status} · Показы {impressions} / Клики {clicks}',
  ],
};

const businessApproval = {
  pageDesc: [
    '신규 등록 업체를 검토합니다. 승인 시 허브 노출·업체주 알림이 발송됩니다.',
    'Review newly registered businesses. Approving triggers hub visibility and owner notifications.',
    'Xem xét các doanh nghiệp mới đăng ký. Khi duyệt sẽ hiển thị trên hub và gửi thông báo cho chủ doanh nghiệp.',
    'Проверка новых зарегистрированных бизнесов. При одобрении включается показ в хабе и уведомление владельцу.',
  ],
  tabPendingReview: ['심사 대기', 'Pending review', 'Chờ duyệt', 'На рассмотрении'],
  tabShadowBlocked: ['스팸 의심', 'Suspected spam', 'Nghi ngờ spam', 'Подозрение на спам'],
  tabApproved: ['승인됨', 'Approved', 'Đã duyệt', 'Одобрено'],
  tabSuspended: ['제재됨', 'Suspended', 'Bị đình chỉ', 'Заблокировано'],
  emptyName: ['(이름 없음)', '(No name)', '(Không có tên)', '(Без названия)'],
  metaRegistered: ['등록: {date}', 'Registered: {date}', 'Đăng ký: {date}', 'Зарегистрировано: {date}'],
  contactLabel: ['연락처: {contact}', 'Contact: {contact}', 'Liên hệ: {contact}', 'Контакт: {contact}'],
  regionLabel: ['지역: {region}', 'Region: {region}', 'Khu vực: {region}', 'Регион: {region}'],
  processing: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  approve: ['✅ 승인', '✅ Approve', '✅ Duyệt', '✅ Одобрить'],
  reject: ['❌ 반려', '❌ Reject', '❌ Từ chối', '❌ Отклонить'],
  statusLabel: ['상태: {status}', 'Status: {status}', 'Trạng thái: {status}', 'Статус: {status}'],
  rejectPrompt: [
    '반려 사유 (선택, 업체주 알림에 포함됩니다)',
    'Rejection reason (optional, included in owner notification)',
    'Lý do từ chối (tùy chọn, sẽ có trong thông báo cho chủ doanh nghiệp)',
    'Причина отклонения (необязательно, будет включена в уведомление владельцу)',
  ],
  errLoadFailed: [
    '목록을 불러오지 못했습니다',
    'Failed to load the list',
    'Không thể tải danh sách',
    'Не удалось загрузить список',
  ],
  errApproveFailed: ['승인 실패', 'Approval failed', 'Duyệt thất bại', 'Ошибка одобрения'],
  errRejectFailed: ['반려 실패', 'Rejection failed', 'Từ chối thất bại', 'Ошибка отклонения'],
  emptyList: [
    '표시할 업체가 없습니다.',
    'No businesses to display.',
    'Không có doanh nghiệp để hiển thị.',
    'Нет бизнесов для отображения.',
  ],
};

const reports = {
  statusPending: ['대기', 'Pending', 'Đang chờ', 'Ожидание'],
  statusReviewing: ['검토중', 'Reviewing', 'Đang xem xét', 'На проверке'],
  statusResolved: ['처리완료', 'Resolved', 'Đã xử lý', 'Решено'],
  statusDismissed: ['기각', 'Dismissed', 'Đã bác bỏ', 'Отклонено'],
  colTarget: ['대상', 'Target', 'Đối tượng', 'Цель'],
  colReporter: ['신고자', 'Reporter', 'Người báo cáo', 'Заявитель'],
  actionWarn: ['경고 발송', 'Send warning', 'Gửi cảnh báo', 'Отправить предупреждение'],
  actionDeletePost: ['게시물 삭제', 'Delete post', 'Xóa bài viết', 'Удалить публикацию'],
  actionSanctionUser: [
    '유저 제재',
    'Sanction user',
    'Xử phạt người dùng',
    'Наказать пользователя',
  ],
  actionDismiss: ['기각', 'Dismiss', 'Bác bỏ', 'Отклонить'],
};

const tierA = {
  pageTitle: ['Tier A 운영 현황', 'Tier A operations', 'Vận hành Tier A', 'Операции Tier A'],
  tabModeration: ['신고/제재', 'Reports/Sanctions', 'Báo cáo/Xử phạt', 'Жалобы/Санкции'],
  tabCampaigns: ['광고/캠페인', 'Ads/Campaigns', 'Quảng cáo/Chiến dịch', 'Реклама/Кампании'],
  tabSystem: ['시스템', 'System', 'Hệ thống', 'Система'],
  dbViewLabel: ['DB 뷰:', 'DB view:', 'Chế độ xem DB:', 'Представление БД:'],
  expiringSuffix: [
    ' · 48시간 이내 만료 {count}건',
    ' · {count} expiring within 48h',
    ' · {count} sắp hết hạn trong 48h',
    ' · {count} истекает в течение 48ч',
  ],
  systemFlagSuffix: [
    ' · feature_flags 토글은 super_admin 전용(시스템·플래그 메뉴)',
    ' · feature_flags toggles are super_admin only (System & flags menu)',
    ' · Bật/tắt feature_flags chỉ dành cho super_admin (menu Hệ thống & cờ)',
    ' · Переключение feature_flags доступно только super_admin (меню Система и флаги)',
  ],
  blockedWarn: [
    '신고·제재 현황은 admin / super_admin만 접근할 수 있습니다.',
    'Report/sanction status is only accessible to admin / super_admin.',
    'Trạng thái báo cáo/xử phạt chỉ admin / super_admin mới truy cập được.',
    'Статус жалоб/санкций доступен только admin / super_admin.',
  ],
  colActionsModeration: ['처리', 'Action', 'Xử lý', 'Действие'],
  colActionsCampaign: ['조치', 'Action', 'Biện pháp', 'Мера'],
  reject: ['반려', 'Reject', 'Từ chối', 'Отклонить'],
  refreshBtn: ['새로고침', 'Refresh', 'Làm mới', 'Обновить'],
  expireAllBtn: [
    '만료 일괄처리',
    'Bulk-expire',
    'Xử lý hết hạn hàng loạt',
    'Массовая обработка истёкших',
  ],
  confirmExpireAll: [
    '만료된 캠페인을 일괄 completed 처리할까요?',
    'Mark all expired campaigns as completed?',
    'Đánh dấu tất cả chiến dịch đã hết hạn là hoàn thành?',
    'Отметить все истёкшие кампании как завершённые?',
  ],
  msgApproved: ['승인했습니다.', 'Approved.', 'Đã duyệt.', 'Одобрено.'],
  msgRejected: ['반려했습니다.', 'Rejected.', 'Đã từ chối.', 'Отклонено.'],
  msgExpiredCount: [
    '{count}건 만료 처리했습니다.',
    '{count} marked as expired.',
    'Đã xử lý hết hạn cho {count} mục.',
    'Обработано как истёкшие: {count}.',
  ],
  emptyLabel: [
    '{label} 데이터가 없습니다.',
    'No {label} data.',
    'Không có dữ liệu {label}.',
    'Нет данных {label}.',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    admin: {
      nav: pick(nav, langIndex),
      ...pick(chrome, langIndex),
      foodIcons: pick(foodIcons, langIndex),
      scam: pick(scam, langIndex),
      ads: pick(ads, langIndex),
      common: pick(adminCommon, langIndex),
      notice: pick(notice, langIndex),
      visaServices: pick(visaServices, langIndex),
      hospitals: pick(hospitals, langIndex),
      rentals: pick(rentals, langIndex),
      academies: pick(academies, langIndex),
      restaurants: pick(restaurants, langIndex),
      hotels: pick(hotels, langIndex),
      businessApproval: pick(businessApproval, langIndex),
      reports: pick(reports, langIndex),
      tierA: pick(tierA, langIndex),
      businessClaims: pick(businessClaims, langIndex),
      bizChargeRequests: pick(bizChargeRequests, langIndex),
      chargeRequests: pick(chargeRequests, langIndex),
      users: pick(users, langIndex),
      subscriptions: pick(subscriptions, langIndex),
      shortsQueue: pick(shortsQueue, langIndex),
      businessVerify: pick(businessVerify, langIndex),
      login: pick(login, langIndex),
      adInquiries: pick(adInquiries, langIndex),
      travelQuotes: pick(travelQuotes, langIndex),
      catalogApproval: pick(catalogApproval, langIndex),
      points: pick(points, langIndex),
      errorLogs: pick(errorLogs, langIndex),
      systemOps: pick(systemOps, langIndex),
    },
  };
}

export const phaseAdminCoreKo = buildLang(0);
export const phaseAdminCoreEn = buildLang(1);
export const phaseAdminCoreVi = buildLang(2);
export const phaseAdminCoreRu = buildLang(3);
